export interface SendAnalyticsBeaconParams {
  /** Analytics event name. Must be on the `/api/beacon` allowlist. */
  event: string;
  /** Free-form property bag attached to the event. */
  properties: object;
}

/**
 * Posts an analytics event via `navigator.sendBeacon('/api/beacon', …)`.
 *
 * Use from `pagehide` / `unload` handlers where the page is about to unload
 * and a normal `fetch` would be cancelled. Shape matches `/api/beacon`'s
 * `{ event, properties }` JSON contract.
 *
 * Returns whatever `navigator.sendBeacon` returns — `true` when the browser
 * queued the request, `false` when it refused (size or context limits).
 */
export function sendAnalyticsBeacon({ event, properties }: SendAnalyticsBeaconParams): boolean {
  // UTC trigger time so PostHog orders by when the event fired, not when this
  // fire-and-forget beacon arrives. `toISOString()` is always UTC.
  const payload = JSON.stringify({ event, properties, timestamp: new Date().toISOString() });
  return navigator.sendBeacon('/api/beacon', new Blob([payload], { type: 'application/json' }));
}
